import React from 'react';
import { Converter } from '@/components/chord_progression/converter/Converter';
import { Layout } from '@/components/layout/Layout';

export const TopPage = () => (
  <Layout>
    <Converter sx={{ mt: 4 }} />
  </Layout>
);
